import './main.css';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import Sider from "../../comps/sider/main";
import { Popconfirm , Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Drawer, Space, Input, Upload } from "antd";
import { CopyTwoTone, EditTwoTone, UploadOutlined, EyeOutlined, SendOutlined, CommentOutlined , LinkOutlined, DeleteOutlined } from '@ant-design/icons';
import { EditText, EditTextarea } from 'react-edit-text';
import callAPI from "../../comps/fetch/main";

function YT() {


    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();



    const [joinWaitlist, setJoinWaitList] = useState()

    const [waitlistJoined, setWaitListJoined] = useState(localStorage.getItem("sell-intrested"))

    

    useEffect(() => {
        if(waitlistJoined == undefined){
            return
        }
    },[waitlistJoined])
    

    useEffect(() => {

        if (joinWaitlist == undefined){
            return
        }

        let user_detail =  JSON.parse(localStorage.getItem("userData"))
        let igid =  localStorage.getItem("ig_id")

        const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
        const CHAT_ID = '776956029';
        const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
        let tele_message = `[SELL Intrested] - user ${user_detail.emailid} = user id = ${user_detail.user_id}`
        let data = {
            chat_id: CHAT_ID,
            text: tele_message
        };


        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            console.log('Message sent successfully:', data);
            setWaitListJoined(true)
            localStorage.setItem("sell-intrested", true)
        })
        .catch(error => {
            console.error('Error sending message:', error);
        });


    } , [joinWaitlist])




    return (
        <div className="page-layout"  style={{backgroundImage: 'linear-gradient(180deg, #f4e9f9 0%, #e9f0fc 100%)'}}>

  {/* your content */}


            {contextHolder}

            <Sider />
            
            <div className="yt-page-content">
                <div className='yt-intro'>
                <iframe src="https://app.youform.com/forms/cznd9bgi" loading="lazy" width="100%" height="700" frameborder="0" marginheight="0" marginwidth="0"></iframe>
                {/* <h1>Sell on InstantDM!!</h1>
                <p>Selling Courses, Digital products, physical products, events, meetings on InstantDM! With affordable platform fee. </p>
                
                
                <div className='shop-list'>
                    <div>
                        
                    </div>
                </div>
                 */}
                {/* <p>Selling Courses, Digital products, physical products, events, meetings on InstantDM!</p> */}
               {/* { waitlistJoined != undefined ?
               
               <div className='create-btn'>
                    Thanks, will notify you!
                </div>
                :  <div className='create-btn'  onClick={() => { setJoinWaitList(true) }}>
                    Join waitlist and get 0% platfrom fee 🎉
                </div>
                }
                <img style={{width:"300px"}} src="https://public-assets.instantdm.com/idm-landing/v3/sell-idm.gif" /> */}
                </div>

            </div>


            

        </div>
    )

}

export default YT;
